import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import GenericDataContext from "./GenericDataContext";

const GenericDataContextProvider = ({children, idPaginaPolkista, idPolkista}) => {
    const polkoClientes = !idPaginaPolkista;

    const context = useMemo(() => ({
        polkoClientes,
        idPaginaPolkista,
        idPolkista
    }), [
        polkoClientes,
        idPaginaPolkista,
        idPolkista
    ]);

    return (
        <GenericDataContext.Provider value={context}>
            {children}
        </GenericDataContext.Provider>
    );
};

GenericDataContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default GenericDataContextProvider;